var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M0 0h5.455v5.455H0zM7.273 0H20v5.455H7.273zM0 7.273h5.455v5.454H0zM7.273 7.273H20v5.454H7.273zM0 14.545h5.455V20H0zM7.273 14.545H20V20H7.273z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }